import ISvgProps from '../../../SvgLoader/ISvgProps';

function SvgSingle(props: ISvgProps) {
	return (
		<svg width={60} height={60} fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="m6.143 46.143 22.424 12.421a2.947 2.947 0 0 0 2.863 0l22.425-12.419a2.874 2.874 0 0 0 1.494-2.52V16.383a2.87 2.87 0 0 0-1.492-2.518L31.43 1.443a2.946 2.946 0 0 0-2.863 0L6.143 13.863a2.872 2.872 0 0 0-1.492 2.52v27.242a2.87 2.87 0 0 0 1.492 2.518Zm.95-1.684a.952.952 0 0 1-.493-.834v-26.72l22.424 12.423v27.278L7.094 44.46Zm45.811 0L30.976 56.607V29.328L53.4 16.905v26.72c0 .346-.19.667-.495.837v-.003ZM29.52 3.127a.988.988 0 0 1 .958 0l21.905 12.13L30 27.656l-22.381-12.4L29.52 3.128Z"
				fill={props.primaryColor}
				stroke={props.primaryColor}
			/>
			<path
				d="M10.5 23.572c-.599 0-1.083.393-1.083.878v17.53c0 .486.484.878 1.083.878s1.083-.392 1.083-.877V24.45a.804.804 0 0 0-.317-.62 1.226 1.226 0 0 0-.766-.258ZM19.728 14.83a.98.98 0 0 0 .476-.125l11.682-6.47v.001a.961.961 0 0 0 .372-1.313.98.98 0 0 0-1.328-.37l-11.681 6.47a.96.96 0 0 0-.467 1.085c.112.425.5.721.946.721ZM14.957 16.506a.98.98 0 0 0 1.328.369l.436-.242v.002a.96.96 0 0 0 .375-1.313.98.98 0 0 0-1.328-.37l-.436.241a.961.961 0 0 0-.375 1.313Z"
				fill={props.secondaryColor}
				stroke={props.secondaryColor}
			/>
		</svg>
	);
}

export default SvgSingle;
